<template>
  <div class="modules">
    <page-header
      title="Edit modules"
      :commands="[
        {
          click: handleAddModuleClick,
          icon: '+',
          text: 'New module',
        },
      ]"
    />
    <div class="container">
      <span v-if="editingItem && !editingItem.id">
        <h4 class="pt-10">New module</h4>
        <span class="activeModule edit-module-row row between pt-10 pb-10">
          <div class="row between wrap w-100 mt-15">
            <div
              :class="`
                    c-v pt-10 pb-10
                    ${
                      field.type && field.type === 'textArea' ? 'w-100' : 'w-50'
                    }
                `"
              v-for="field in moduleFields"
              :key="field.name || field"
            >
              <label class="pb-5 d-block">
                {{ field.name || field }}
              </label>
              <my-inputs
                :values="editingItem"
                :name="field.name || field"
                :handleChange="updateParam"
                :type="field.type || 'text'"
              />
            </div>
            <div class="w-100 pt-15 row right">
              <my-inputs
                value="Cancel"
                :handleClick="() => handleModuleClick(null)"
                type="button_blue"
              />
              <my-inputs
                value="Save"
                :handleClick="handleSaveClick"
                type="button_green_ml-10"
              />
            </div>
          </div>
        </span>
      </span>

      <span v-for="category in Object.keys(moduleData)" :key="category">
        <h4 v-if="category === 'accessOnly'" class="pt-10">Base modules</h4>
        <h4 v-else class="pt-10">{{ category }}</h4>
        <span
          v-for="(linkItem, index) in [...moduleData[category]]"
          :key="index + '-' + category"
          class="activeModule edit-module-row row between pt-10 pb-10"
          @click="() => handleModuleClick(linkItem)"
        >
          <div class="w-100">
            {{ linkItem.name }}
          </div>
          <p class="light em normal p-0 m-0 pt-5" v-if="linkItem.description">
            {{ linkItem.description }}
          </p>
          <div
            class="row between wrap w-100 mt-15"
            v-if="editingItem && linkItem.id === editingItem.id"
          >
            <div
              :class="`
                    c-v pt-10 pb-10
                    ${
                      field.type && field.type === 'textArea' ? 'w-100' : 'w-50'
                    }
                `"
              v-for="field in moduleFields"
              :key="field.name || field"
            >
              <label class="pb-5 d-block">
                {{ field.name || field }}
              </label>
              <my-inputs
                :values="editingItem"
                :name="field.name || field"
                :handleChange="updateParam"
                :type="field.type || 'text'"
              />
            </div>
            <div class="w-100 pt-15 row right">
              <my-inputs
                value="Cancel"
                :handleClick="() => handleModuleClick(null)"
                type="button_blue"
              />
              <my-inputs
                value="Delete"
                :handleClick="handleDeleteClick"
                type="button_red_ml-10"
              />
              <my-inputs
                value="Save"
                :handleClick="handleSaveClick"
                type="button_green_ml-10"
              />
            </div>
          </div>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import MyInputs from "@/myComponents/MyInputs.vue";
import PageHeader from "../../components/PageHeader.vue";
import TextComponent from '../../components/TextComponent.vue';
const moduleFields = [
  "name",
  "parent",
  "ref",
  "link",
  { name: "description", type: "textArea" },
];
export default {
  name: "edit-site-modules",
  components: { PageHeader, MyInputs },
  data: () => ({
    editingItem: null,
    moduleFields,
  }),
  methods: {
    handleAddModuleClick() {
      const newModule = this.moduleFields.reduce((prev, curr) => {
        prev[curr.name || curr] = null;
        return prev;
      }, {});
      this.editingItem = newModule;
    },
    async handleSaveClick() {
      await this.$store.dispatch("saveModule", this.editingItem);
      this.handleModuleClick(null)
    },
    async handleDeleteClick () {
      this.$store.commit("setModal", {
        component: TextComponent,
        mounted: true,
        header: "Confirm delete",
        props: {
          text:
            `Are you sure you want to delete object ${this.editingItem.name}?`
        },
        goodClick: () => {
          this.$store.dispatch("deleteModule", this.editingItem.id);
          this.handleModuleClick(null)
        },
      });
    },
    updateParam(param, value) {
      this.editingItem[param] = value;
    },
    handleModuleClick(item) {
      if (item === null) {
        this.editingItem = null;
      } else if (!this.editingItem || this.editingItem.id !== item.id) {
        this.editingItem = { ...item };
      }
    },
  },
  computed: {
    moduleData() {
      return this.$store.getters.moduleManager.data;
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.edit-module-row {
  border-radius: 5px;
  background-color: rgb(243, 243, 243);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
  align-items: center;
  padding: 18px 15px 15px 15px;
  margin-bottom: 10px;
  font-weight: bold;
  color: rgb(88, 88, 88);
  border-left: 10px solid $red;
  transition: border-color 0.3s;
  flex-wrap: wrap;
  &:hover {
    background-color: #fff;
    cursor: pointer;
  }
  &.activeModule {
    border-left: 10px solid $green;
  }
}
</style>
